<script lang="ts" setup name="Person">
import { ElBacktop } from "element-plus";
import { useDesign } from "@/hooks/useDesign";
const { b } = useDesign();
const className = b("backtop");
</script>
<template>
  <ElBacktop :class="className">
    <svg class="icon" aria-hidden="true">
      <use xlink:href="#icon-huojian"></use>
    </svg>
  </ElBacktop>
</template>

<style scoped>
.icon {
  width: 1.3em;
  height: 1.3em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
